/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/GoalMetricReport', 'model/GoalMetric', 'model/GoalMetricReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/GoalMetricReport'), require('../model/GoalMetric'), require('../model/GoalMetricReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.GoalMetricApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.GoalMetricReport, root.ForStractionServiceApi.GoalMetric, root.ForStractionServiceApi.GoalMetricReportPaginationSlice);
  }
}(this, function(ApiClient, GoalMetricReport, GoalMetric, GoalMetricReportPaginationSlice) {
  'use strict';

  /**
   * GoalMetric service.
   * @module api/GoalMetricApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new GoalMetricApi. 
   * @alias module:api/GoalMetricApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the goalMetricAddAllAndLoadPut operation.
     * @callback module:api/GoalMetricApi~goalMetricAddAllAndLoadPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/GoalMetricReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAllAndLoad
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/GoalMetricReport>} body 
     * @param {module:api/GoalMetricApi~goalMetricAddAllAndLoadPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/GoalMetricReport>}
     */
    this.goalMetricAddAllAndLoadPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling goalMetricAddAllAndLoadPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling goalMetricAddAllAndLoadPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [GoalMetricReport];

      return this.apiClient.callApi(
        '/GoalMetric/addAllAndLoad', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the goalMetricAddAndLoadPut operation.
     * @callback module:api/GoalMetricApi~goalMetricAddAndLoadPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GoalMetricReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAndLoad
     * @param {String} _4SAPIAppID 
     * @param {module:model/GoalMetricReport} body 
     * @param {module:api/GoalMetricApi~goalMetricAddAndLoadPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GoalMetricReport}
     */
    this.goalMetricAddAndLoadPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling goalMetricAddAndLoadPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling goalMetricAddAndLoadPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = GoalMetricReport;

      return this.apiClient.callApi(
        '/GoalMetric/addAndLoad', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the goalMetricAggregateMetricGet operation.
     * @callback module:api/GoalMetricApi~goalMetricAggregateMetricGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * aggregateMetric
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/GoalMetricApi~goalMetricAggregateMetricGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.goalMetricAggregateMetricGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling goalMetricAggregateMetricGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling goalMetricAggregateMetricGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/GoalMetric/aggregateMetric', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the goalMetricDeleteAllPut operation.
     * @callback module:api/GoalMetricApi~goalMetricDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/GoalMetricApi~goalMetricDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.goalMetricDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling goalMetricDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling goalMetricDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/GoalMetric/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the goalMetricDeleteGet operation.
     * @callback module:api/GoalMetricApi~goalMetricDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} metricID 
     * @param {module:api/GoalMetricApi~goalMetricDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.goalMetricDeleteGet = function(_4SAPIAppID, metricID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling goalMetricDeleteGet";
      }

      // verify the required parameter 'metricID' is set
      if (metricID == undefined || metricID == null) {
        throw "Missing the required parameter 'metricID' when calling goalMetricDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'metricID': metricID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/GoalMetric/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the goalMetricEditAllPut operation.
     * @callback module:api/GoalMetricApi~goalMetricEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/GoalMetric>} body 
     * @param {module:api/GoalMetricApi~goalMetricEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.goalMetricEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling goalMetricEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling goalMetricEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/GoalMetric/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the goalMetricEditPut operation.
     * @callback module:api/GoalMetricApi~goalMetricEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/GoalMetric} body 
     * @param {module:api/GoalMetricApi~goalMetricEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.goalMetricEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling goalMetricEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling goalMetricEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/GoalMetric/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the goalMetricLoadGet operation.
     * @callback module:api/GoalMetricApi~goalMetricLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GoalMetricReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} metricID 
     * @param {module:api/GoalMetricApi~goalMetricLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GoalMetricReport}
     */
    this.goalMetricLoadGet = function(_4SAPIAppID, metricID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling goalMetricLoadGet";
      }

      // verify the required parameter 'metricID' is set
      if (metricID == undefined || metricID == null) {
        throw "Missing the required parameter 'metricID' when calling goalMetricLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'metricID': metricID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = GoalMetricReport;

      return this.apiClient.callApi(
        '/GoalMetric/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the goalMetricSearchPut operation.
     * @callback module:api/GoalMetricApi~goalMetricSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/GoalMetricReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/GoalMetric>} body 
     * @param {module:api/GoalMetricApi~goalMetricSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/GoalMetricReport>}
     */
    this.goalMetricSearchPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling goalMetricSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling goalMetricSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [GoalMetricReport];

      return this.apiClient.callApi(
        '/GoalMetric/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the goalMetricSearchSlicePut operation.
     * @callback module:api/GoalMetricApi~goalMetricSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GoalMetricReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/GoalMetric} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/GoalMetricApi~goalMetricSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GoalMetricReportPaginationSlice}
     */
    this.goalMetricSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling goalMetricSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling goalMetricSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = GoalMetricReportPaginationSlice;

      return this.apiClient.callApi(
        '/GoalMetric/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
